const DUMMY_BASE = "http://localhost";

export const appendQueryParameters = (url: string, params: Record<string, string | null>): string => {
	const nonNullParams = Object.entries(params).filter((entry): entry is [string, string] => entry[1] !== null);

	if (nonNullParams.length === 0) {
		return url;
	}

	const parsed = new URL(url, DUMMY_BASE);

	for (const [key, value] of nonNullParams) {
		parsed.searchParams.set(key, value);
	}

	return parsed.toString().replace(DUMMY_BASE, "");
};

export const appendReturnTo = (url: string, returnTo: string | null): string =>
	appendQueryParameters(url, { returnTo });
